import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import CFSelect from "../shared/forms/CFSelect";

function addedCtaIds() {
  return Array.from(
    document.querySelectorAll(".broadcasts-cta[data-cta-id]")
  ).map((element) => String(element.getAttribute("data-cta-id")));
}

const BroadcastCtaSelect = ({
  options,
  excludeIds = [],
  name = "broadcasts_cta[cta_id]",
}) => {
  const inputRef = useRef(null);
  const [selected, setSelected] = useState(null);
  const [excludedIds, setExcludedIds] = useState(
    () => new Set(excludeIds.map(String))
  );

  const visibleOptions = useMemo(
    () => options.filter((option) => !excludedIds.has(String(option.value))),
    [options, excludedIds]
  );

  function syncExcludedFromDom() {
    setExcludedIds(new Set(addedCtaIds()));
  }

  useEffect(() => {
    const form = inputRef.current?.form;
    if (!form) return;

    const handleSuccess = () => {
      setSelected(null);
      syncExcludedFromDom();
    };

    const handleSubmit = (event) => {
      if (!inputRef.current?.value) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    form.addEventListener("ajax:success", handleSuccess);
    form.addEventListener("submit", handleSubmit, true);
    return () => {
      form.removeEventListener("ajax:success", handleSuccess);
      form.removeEventListener("submit", handleSubmit, true);
    };
  }, []);

  return (
    <React.Fragment>
      <input
        ref={inputRef}
        type="hidden"
        name={name}
        value={selected ? selected.value : ""}
      />
      <CFSelect
        options={visibleOptions}
        value={selected}
        onChange={setSelected}
        onMenuOpen={syncExcludedFromDom}
        placeholder="Add a campaign"
      />
    </React.Fragment>
  );
};

BroadcastCtaSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
        .isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  excludeIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  name: PropTypes.string,
};

export default BroadcastCtaSelect;
